export default {
  // 备忘录
  utils: {
    plus: 'plus',
    reduce: 'minus',
    ride: 'multiply',
    except: 'divide',
    Involution: 'involution',
    leftBrackets: 'left bracket',
    lrightBrackets: 'right bracket',
    chuanLian: 'series',
    dengyu: 'equal',
    budengyu: 'unequal',
    dayu: 'greater than',
    xiaoyu: 'less than',
    dayudengyu: 'greater than or equal to',
    xiaoyugengyu: 'less than or equal',
    dataAndTime: 'date and time',
    example: 'example',
    formulaInfo1: 'Returns the positive value of the year in the specified date field',
    formulaInfo2: 'Returns a positive number for the month in the specified date field',
    formulaInfo24: 'Returns the number of days of a month in the specified date field',
    formulaInfo3: 'Returns the date and time that represents the current time',
    formulaInfo4: 'Returns the date representing the current time',
    formulaInfo5: 'Returns the number of days between two dates.',
    Y: 'year',
    M: 'month',
    D: 'day',
    H: 'hour',
    N: 'minutes',
    S: 'seconds',
    formulaInfo6:
      'Returns the new datetime value on the basis of adding a period of time to the specified date.Y: year, M: month, D: day, H: hour, N: minutes, S: seconds',
    formulaInfo7: 'Returns the time between two dates, Y: year, M: month, D: day',
    formulaInfo42:
      "Uncontacted days =EXTRACT('D','current_date',2017-12-25), calculate the result value in real time",
    formulaInfo44:
      'Returns the time between two dates Y: year, M: month, D: day, H: hour, N: minutes, S: seconds',
    formulaInfo45:
      "Duration =EXTRACT('H','current_timestamp',2017-12-25 20:15:00), real-time calculation of result value",
    formulaInfo8: 'Create the date by year, month, and day',
    number: 'number',
    formulaInfo9: 'Returns the absolute value of the value (minus signs)',
    formulaInfo46: 'Convert lowercase numbers to uppercase Chinese',
    logic: 'logic',
    formulaInfo10:
      'IF the condition is met (when the Boolean expression returns TRUE), the statement is executed after the IF keyword and its condition.The optional ELSE keyword introduces the alternate statement that executes when the IF condition is not met',
    formulaInfo11:
      "IF score ==100 THEN 'AA' ELSE IF score >=90 THEN 'A' ELSE IF score >=80 THEN 'B' ELSE IF score >=70 THEN 'C' ELSE IF score >=60 THEN 'D' ELSE 'F' END",
    formulaInfo12:
      'Determines whether the expression is empty (blank) and returns TRUE if so;This function returns FALSE if it contains a value',
    formulaInfo13:
      'ISNULL(order. Total amount,0) displays the order if the order. Total amount is not NULL. Displays the 0 after a comma if NULL',
    formulaInfo14: 'Checks if all parameters are TRUE and returns TRUE if all parameters are TRUE',
    formulaInfo15: 'Checks if the expression has a value and returns TRUE if it does not',
    formulaInfo16:
      'Inverse function, where the user makes sure that a value is not equal to a particular value',
    formulaInfo17: "IF NOT(age >=18) THEN ' Underage,cannot enter the game ' END",
    formulaInfo18: 'if the text value is a number,return to TRUE,or FALSE if not',
    formulaInfo19: 'Checks whether any of the parameters are TRUE and returns TRUE if one is',
    formulaInfo20: 'Check if the text contains compare_text and return TRUE if so',
    formulaInfo21: "CONTAINS(customer address,' shenzhen ')=TRUE",
    formulaInfo22: 'Returns TRUE if the text matches the regular expression regex_text',
    formulaInfo23: 'phone',
    text: 'text',
    formulaInfo25: 'Returns a specified number of characters from the beginning of a text string',
    formulaInfo26: 'Returns the number of characters contained in the specified text string',
    formulaInfo27:
      'Returns the specified number of characters from the right side of the text string',
    formulaInfo28: 'Converts a value to text in a standard display format',
    formulaInfo29: 'Converts the text string to a numeric type',
    formulaInfo30:
      'Returns the character in the middle of the string, given the starting position and length of the string',
    formulaInfo31:
      'Checks if the text begins with a specific character, returns TRUE if so, or FALSE if not',
    formulaInfo43: "BEGINS(Member Card Number,'801')",
    summary: 'summary',
    formulaInfo32: 'Returns the number of items in the group',
    formulaInfo33: 'COUNT(product. Product number) returns the number of items in the group',
    formulaInfo34: 'Returns the sum of the items in the group.',
    formulaInfo35: 'Total amount of customer transaction =SUM(contract. Total amount)',
    formulaInfo36: 'Returns the smallest of a series of Numbers',
    formulaInfo37: 'Student minimum score =MIN(Score)',
    formulaInfo38: 'Returns the largest number in a series of Numbers',
    formulaInfo39: 'Student minimum score =MAN(Score)',
    formulaInfo40: 'Returns the average value in the group',
    formulaInfo41: 'Member average consumption =AVG(sales order. Amount)',
    noPicture: 'no picture',
    xiuxian: 'relaxation ',
    relax: 'relax',
    business: 'business',
    hezuo: 'cooperation ',
    meeting: 'meeting',
    up: 'up',
    administration: 'administration',
    quwei: 'interest',
    silent: 'silent',
    dushi: 'city',
    qinliang: 'cool and refreshing',
    menghuan: 'dream',
    richu: 'sunrise',
    chuxia: 'early summer',
    reqing: 'enthusiasm',
    yaoyuan: 'remote',
    shenye: 'late at night',
    work: 'work',
    B2cPlatform: 'e-commerce platform',
    ITInternet: 'Internet',
    teachTrain: 'educational training',
    houseCenter: 'house agent',
    jinrongBaoxian: 'finance and insurance',
    wuliuYunshu: 'logistics transportation',
    jiazhengFuwu: 'household service',
    qicheFuwu: 'automobile service',
    yiliaoZhiyao: 'medical and pharmaceutical',
    lvshiAnjian: 'law case',
    nonglinye: 'Agriculture Animal Husbandry and Fishery',
    guangaoMeiti: 'advertising media',
    other: 'other',
    xingzhengBangong: 'administration',
    renliZiyuan: 'human resource',
    kehuGuanli: 'customer management',
    huiyuanGuanli: 'member management',
    shouhouGuanli: 'after-sale management',
    jinxiaocun: 'invoicing',
    cangkuGuanli: 'warehouse management',
    subMenu: 'submenu',
    view: 'view',
    chart: 'chart',
    taskYongdaotu: 'mission lane diagram',
    logOutOfDate: 'login date',
    networkExceptionTryAgain: 'Network exception, please try again later',
    browserDontSupportCanvas: 'Your browser version does not support canvas',
    pwdRuleInfo1: 'Does not match the minimum password length',
    pwdRuleInfo2: 'Include alphanumeric characters',
    pwdRuleInfo3: 'Include letters, Numbers, and special characters',
    pwdRuleInfo4: 'Include Numbers and upper and lower case letters',
    pwdRuleInfo5: 'Include Numbers, uppercase letters, and special characters',
    listChart: 'List type',
    summaryChart: 'summary type',
    matrixChart: 'matrix',
    barChart: 'bar graph',
    stackChart: 'stacked bar charts',
    stripChart: 'bar chart',
    stackStripChart: 'stacked bar chart',
    areachart: 'area chart',
    scatterChart: 'scatter chart',
    linechart: 'line chart',
    pie1Chart: 'pie1',
    pie2Chart: 'pie2',
    ringChart: 'doughnut chart',
    funnelChart: 'funnel plot',
    mapChart: 'map',
    gaugeChart: 'meter diagram',
    valueNum: 'value 1',
    valueSvg: 'value 2',
    radarChart1: 'Radar chart 1',
    radarChart2: 'Radar chart 2',
    ganttChart: 'Gantt chart',
    dimensionValue1: 'One or more dimensions, one or more values',
    dimensionValue2: 'One or two dimensions, one to three values',
    dimensionValue3: 'one dimension, one number',
    dimensionValue4: 'a numerical',
    dimensionValue5: 'one dimension (provincial component), one value',
    dimensionValue6: 'one dimension, one or more values',
    dimensionValue7: 'one to three dimension, one or more values',
    selectEmoji: 'select emoji',
    emoji1: 'grin',
    emoji2: 'tongue',
    emoji3: 'blush',
    emoji4: 'chuckle',
    emoji5: 'wave',
    emoji6: 'hammer',
    emoji7: 'speechless',
    emoji8: 'pig',
    emoji9: 'rose',
    emoji10: 'crying',
    emoji11: 'almost crying',
    emoji12: 'silent',
    emoji13: 'ruthless',
    emoji14: 'scream',
    emoji15: 'frown',
    emoji16: 'shit',
    emoji17: 'bomb',
    emoji18: 'cleaver',
    emoji19: 'cute',
    emoji20: 'drool',
    emoji21: 'shy',
    emoji22: 'smug',
    emoji23: 'puke',
    emoji24: 'smile',
    emoji25: 'angry',
    emoji26: 'awkward',
    emoji27: 'terrified',
    emoji28: 'blush',
    emoji29: 'heart',
    emoji30: 'mouth',
    emoji31: 'rolling eyes',
    emoji32: 'smug',
    emoji33: 'sad',
    emoji34: 'surprised',
    emoji35: 'confused',
    emoji36: 'sleepy',
    emoji37: 'kiss',
    emoji38: 'gelasmus',
    emoji39: 'love',
    emoji40: 'miserable',
    emoji41: 'grimace',
    emoji42: 'grin',
    emoji43: 'strive',
    emoji44: 'scowl',
    emoji45: 'right humph',
    emoji46: 'hug',
    emoji47: 'trick',
    emoji48: 'blowkiss',
    emoji49: 'despise',
    emoji50: 'dizzy',
    emoji51: 'haidern',
    emoji52: 'please',
    emoji53: 'thumbs up',
    emoji54: 'thumbs down',
    emoji55: 'shake',
    emoji56: 'victory',
    emoji57: 'fight',
    emoji58: 'wilt',
    emoji59: 'rice',
    emoji60: 'cake',
    emoji61: 'watermelon',
    emoji62: 'beer',
    emoji63: 'ladybird',
    emoji64: 'beckon',
    emoji65: 'ok',
    emoji66: 'gesture',
    emoji67: 'coffee',
    emoji68: 'moon',
    emoji69: 'dagger',
    emoji70: 'tremble',
    emoji71: 'dish',
    emoji72: 'fist',

    // 2021-03-31
    formulaInfo47: '',
    formulaInfo48: '',
    formulaInfo49: '',
    formulaInfo50: '',
    formulaInfo51: '',
    formulaInfo52: '',
    formulaInfo53: '',
    stopMember: 'Deactivated personnel'
  }
}
